import React, { Component } from "react";
// import $ from 'jquery'; 


// import ButtonRedirect from "../components/main/ButtonRedirect";
// import SearchBar from "../components/main/SearchBar";

import FilterDropdown from "../components/filterpage/FilterDropdown";
import FilterMinMax from "../components/filterpage/FilterMinMax";
import FilterCheckbox from "../components/filterpage/FilterCheckbox";

// import { MdExpandMore } from "react-icons/md";
// import { MdExpandLess } from "react-icons/md";


import '../components/filterpage/AllFilters.css';



export default class FilterPage extends Component {

  componentDidMount(){
    document.title = "Data Access - ImmuneSpace"
  }
  
  constructor(props) {
    super(props);

    this.state = {
      searchdropdown: '',
      searchslider: '',
      searchcheckbox: '',
      age_min: 0,
      age_max: 100,
      year_min: 2012,
      year_max: new Date().getFullYear(),
    };

  }


  onDropdownChange = (filters_selected) => {

    var search = '';

    for (var col in filters_selected){

      if (filters_selected[col] !== null){
        if (filters_selected[col].length > 0){
          var col_search = col+'=';
  
          for (var item of filters_selected[col]){
            col_search += item.value + '+';
          }
  
          // remove last +
          col_search = col_search.slice(0, -1);
          
          search += col_search + '&'
  
        }
      }
    }

    // remove last &
    search = search.slice(0, -1);

    this.setState({searchdropdown: search});
  }


  onSliderChange = (slider_selected) => {

    var search = '';

    for (var col in slider_selected){

      if (Object.keys(slider_selected[col]).length > 0){

        // for age
        if (col === 'age_filter'){

          if (slider_selected[col].min !== this.state.age_min){
            search += 'age_filter_min=' + slider_selected[col].min + '&';
          }

          if (slider_selected[col].max !== this.state.age_max){
            search += 'age_filter_max=' + slider_selected[col].max + '&';
          }

        }

        // for year
        else if (col === 'year_filter'){
          
          if (slider_selected[col].min !== this.state.year_min){
            search += 'year_filter_min=' + slider_selected[col].min + '&';
          }

          if (slider_selected[col].max !== this.state.year_max){
            search += 'year_filter_max=' + slider_selected[col].max + '&';
          }
        }

                
      }
    }

    // remove last &
    search = search.slice(0, -1);

    this.setState({searchslider: search});

  }


  onCheckboxChange = (checkbox_selected) => {
    var search = '';
    if (checkbox_selected === true){
      search = 'hasSignature=true';
    }

    this.setState({searchcheckbox: search});
  }

    
  render(){
    return (
      <div className="FilterPage container">

          <div id="hipc-3-data">

            <div>
                <div class="filters-page-title">
                    <h1>ImmuneSpace Data Access</h1>
                    <a class="info-icon" title="Click to go to tutorial" href="/query-app-tutorial" target="_blank"><i class="fa-regular fa-circle-question"></i></a>
                    <p>Looking for the <a href="https://datatools.immunespace.org/" target="_blank">legacy ImmuneSpace ?</a></p>
                </div>
                <div class="filters-page-description">
                    <div>The ImmuneSpace Data Access searches ImmPort data submitted using our <a href="/hipc-data-standards">data standards and templates.</a></div>
                    <div class="info">Select one or more filter parameters to query ImmuneSpace data.</div>
                </div>
            </div>


            <div className="row">

              <div className="col-sm-12 col-lg-6 col-md-6 filters-group">

                <div className="row">

                  <div className="filters-group-title">
                      <div>Studies</div>
                  </div>

                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <FilterDropdown title="Study ID" id="study_id_filter" data="get_study_id_dropdown" finder={false} example='Ex: SDY112' onDropdownChange={this.onDropdownChange} selected={null} />
                  </div>

                  <div className="col-lg-6 col-md-12 col-sm-12">
                    <FilterDropdown title="PMID" id="pmid_filter" data="get_pubmed_id_dropdown" finder={false} example='Ex: 28092664' onDropdownChange={this.onDropdownChange} selected={null} />
                  </div>

                  <div className="col-12">
                    <FilterDropdown title="Authors" id="authors_filter" data="get_authors_dropdown" finder={false} example='Ex: Sette A' onDropdownChange={this.onDropdownChange} selected={null} />
                  </div>

                  <div className="col-12">
                    <FilterCheckbox disabled title="hasSignature" id="has_signature" text="Has Signature ?" onCheckboxChange={this.onCheckboxChange} isSelected={false} />
                  </div>

                  <div className="col-12">
                    <FilterMinMax title="Initial Data Release" id="year_filter" onSliderChange={this.onSliderChange} selected_min={this.state.year_min} selected_max={this.state.year_max} />
                  </div>

                </div>

              </div>

              <div className="col-sm-12 col-lg-6 col-md-6 filters-group">

                <div className="row">

                  <div className="filters-group-title">
                    <div>Participants</div>
                  </div>

                  <div className="col-12">
                    <FilterDropdown title="Participant ID" id="participant_id_filter" data="get_participant_id_dropdown" finder={false} example='Ex: SUB71252' onDropdownChange={this.onDropdownChange} selected={null} />
                  </div>

                  <div className="col-12">
                    <FilterDropdown title="Biological Sex" id="sex_filter" data="get_biological_sex_dropdown" example='Ex: female' finder={true} onDropdownChange={this.onDropdownChange} selected={null} />
                  </div>

                  <div className="col-12">
                    <FilterMinMax title="Age" id="age_filter" onSliderChange={this.onSliderChange} selected_min={this.state.age_min} selected_max={this.state.age_max} />
                  </div>

                  <div className="col-12">
                    <FilterDropdown title="Race" id="race_filter" data="get_race_dropdown" finder={true} example='Ex: white' onDropdownChange={this.onDropdownChange} selected={null} />
                  </div>

                </div>

              </div>

              <div className="col-sm-12 col-lg-6 col-md-6 filters-group">

                <div className="row">

                  <div className="filters-group-title">
                      <div>Events / Samples</div>
                  </div>

                  <div className="col-12">
                    <FilterDropdown title="Event Type" id="event_type_filter" data="get_event_type_dropdown" finder={true} example="Ex: vaccination" onDropdownChange={this.onDropdownChange} selected={null} />
                  </div>

                  <div className="col-12 side-filter">
                    <FilterDropdown title="Event Category" id="event_category_filter" data="get_event_category_dropdown" finder={true} example="Ex: exposure" onDropdownChange={this.onDropdownChange} selected={null} />
                  </div>

                  <div className="col-12">
                    <FilterDropdown title="Material" id="material_filter" data="get_material_dropdown" finder={true} example="Ex: influenza a virus" onDropdownChange={this.onDropdownChange} selected={null} />
                  </div>

                  <div className="col-12">
                    <FilterDropdown title="Disease Name" id="disease_filter" data="get_disease_dropdown" finder={true} example="Ex: influenza" onDropdownChange={this.onDropdownChange} selected={null} />
                  </div>

                </div>
              
              </div>

              <div className="col-sm-12 col-lg-6 col-md-6 filters-group">

                <div className="row">

                  <div className="filters-group-title">
                      <div>Assays / Assessments</div>
                  </div>

                  <div className="col-12">
                    <FilterDropdown disabled title="Tissue Sampled" id="tissue_sampled_filter" data="" finder={false} example="Ex: blood" onDropdownChange={this.onDropdownChange} selected={null} />
                  </div>

                  <div className="col-12">
                    <FilterDropdown title="Sample Type" id="sample_type_filter" data="get_sample_type_dropdown" finder={true} example="Ex: blood" onDropdownChange={this.onDropdownChange} selected={null} />
                  </div>

                  <div className="col-12">
                    <FilterDropdown title="Assay Type" id="assay_filter" data="get_assay_type_dropdown" finder={true} example="Ex: ELISA" onDropdownChange={this.onDropdownChange} selected={null} />
                  </div>

                  <div className="col-12">
                    <FilterDropdown title="Target Entity (analyte)" id="analyte_filter" data="get_target_entity_dropdown" finder={true} example="Ex: IL1A" onDropdownChange={this.onDropdownChange} selected={null} />
                  </div>

                </div>

              </div>

            </div>        


            <div className="button-redirect">
              <a href={`/query/results/?` 
                            + this.state.searchdropdown 
                            + ((this.state.searchdropdown !== '' && this.state.searchcheckbox !== '') ? '&' : '') 
                            + (this.state.searchcheckbox !== '' ? this.state.searchcheckbox : '') 
                            + (((this.state.searchcheckbox !== '' || this.state.searchdropdown !== '') && this.state.searchslider !== '') ? '&' : '') 
                            + (this.state.searchslider !== '' ? this.state.searchslider : '') 
              }>
                Search
              </a>
            </div>

          </div>

        </div>

    );
  }
}

